import type { AppRole } from "@/lib/auth/rbac-config";
import { ROLE_ALIASES } from "@/lib/auth/rbac-config";
import { ROLE_PERMISSION_CODES } from "@/seeders/role-permissions.seed";
import type { AuthApiPermission, AuthApiUser } from "@/types/auth-api-types";
import type { AuthProfile } from "@/types/auth-types";

function resolveMockRoleCode(value: string | undefined): AppRole {
  if (!value) return "ADMIN";
  const key = value.trim().toUpperCase().replace(/\s+/g, "_");
  return ROLE_ALIASES[key] ?? "ADMIN";
}

function apiPermissionsForRole(role: AppRole): AuthApiPermission[] {
  const codes = ROLE_PERMISSION_CODES[role] ?? ROLE_PERMISSION_CODES.ADMIN;

  return codes.map((code) => {
    const separator = code.indexOf(":");
    if (separator === -1) {
      return { code };
    }

    return {
      code,
      resource: code.slice(0, separator),
      action: code.slice(separator + 1),
    };
  });
}

/** Mock `/api/me` user with backend-shaped permissions for local `useMock` mode. */
export function buildMockAuthUser(profile: AuthProfile): AuthApiUser {
  const role = resolveMockRoleCode(process.env.NEXT_PUBLIC_DEV_ROLE);

  return {
    id: "mock-user",
    email: profile.email,
    name: profile.name,
    role,
    status: "ACTIVE",
    permissions: apiPermissionsForRole(role),
  };
}
